import { Component, OnInit } from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {ConfService} from '../../conf.service';

@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss']
})
export class CreditsComponent implements OnInit {

  constructor(public settingComp: SettingsComponent, private appComp: AppComponent, private confPost: ConfService) { }

  captchaSiteKey: string;
  captach: string;
  couponCode: string;

  ngOnInit() {
    this.appComp.currentPageTitle = 'Manage Credits';
    this.appComp.ribbon = 'Credits';
    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }
    this.confPost.getCaptchaSiteKey().subscribe(response => {
      this.captchaSiteKey = response[0]['value'];
    });

  }

}
